<template>
  <header :class="{ nyHeader: innerPage, on: true }">
    <div class="header-container">
      <div class="wrap1 flexbet">
        <div class="logo">
          <router-link to="/">
            <img src="/images/logo.png" class="site-logo" alt="Chenghong Technology">
          </router-link>
        </div>
        <div class="rightDiv">
          <a
            href="#"
            class="mbtn"
            id="menu-button"
            role="button"
            :aria-expanded="menuOpen ? 'true' : 'false'"
            aria-label="Menu"
            @click.prevent="toggleMobileMenu"
          ></a>
          <div class="menu" id="cssmenu">
            <ul class="clearfix fl">
              <li class="default" :class="{ on: isHomeActive }">
                <router-link to="/" @click.native="closeMobileMenu">{{ $t('nav.home') }}</router-link>
              </li>
              <li
                class="proLi has-sub"
                :class="{ on: isActive('/product'), 'is-open': openSub === 'product' }"
              >
                <router-link to="/product/" @click.native="onParentNavClick('product', $event)">{{ $t('nav.products') }}</router-link>
                <span class="submenu-button" :class="{ 'submenu-opened': openSub === 'product' }" @click.prevent="toggleSub('product')"></span>
                <ul v-if="productMegaNav.length" class="ch-mega ch-mega--product" :class="{ open: openSub === 'product' }">
                  <div class="ch-mega__panel wrap">
                    <div
                      v-for="cat in productMegaNav"
                      :key="cat.slug"
                      class="ch-mega__col"
                    >
                      <router-link class="ch-mega__heading" :to="'/product/' + cat.slug + '/'" @click.native="closeMobileMenu">
                        {{ navItemLabel(cat, 'productNav') }}
                      </router-link>
                      <router-link
                        v-for="product in cat.products"
                        :key="product.id"
                        class="ch-mega__link"
                        :to="productDetailLink(cat.slug, product.id)"
                        @click.native="closeMobileMenu"
                      >
                        <span>{{ navItemLabel(product, 'product') }}</span>
                        <i class="font_family icon-youjiantou"></i>
                      </router-link>
                    </div>
                  </div>
                </ul>
              </li>
              <li
                class="solLi has-sub"
                :class="{ on: isActive('/case'), 'is-open': openSub === 'case' }"
              >
                <router-link to="/case/" @click.native="onParentNavClick('case', $event)">{{ $t('nav.applications') }}</router-link>
                <span class="submenu-button" :class="{ 'submenu-opened': openSub === 'case' }" @click.prevent="toggleSub('case')"></span>
                <ul v-if="applicationMegaNav.length" class="ch-mega ch-mega--case" :class="{ open: openSub === 'case' }">
                  <div class="ch-mega__panel wrap">
                    <router-link
                      v-for="item in applicationMegaNav"
                      :key="item.slug"
                      class="ch-mega__link ch-mega__link--tile"
                      :to="'/case/' + item.slug + '/'"
                      @click.native="closeMobileMenu"
                    >
                      <span>{{ item.name || navItemLabel(item, 'applicationNav') }}</span>
                      <i class="font_family icon-youjiantou"></i>
                    </router-link>
                  </div>
                </ul>
              </li>
              <li
                class="default has-sub"
                :class="{ on: isActive('/news'), 'is-open': openSub === 'news' }"
              >
                <router-link to="/news/" @click.native="onParentNavClick('news', $event)">{{ $t('nav.news') }}</router-link>
                <span class="submenu-button" :class="{ 'submenu-opened': openSub === 'news' }" @click.prevent="toggleSub('news')"></span>
                <ul :class="{ open: openSub === 'news' }">
                  <li v-for="item in newsNav" :key="item.slug">
                    <router-link :to="'/news/' + item.slug + '/'" @click.native="closeMobileMenu">{{ navItemLabel(item, 'newsNav') }}</router-link>
                  </li>
                </ul>
              </li>
              <li
                class="default has-sub"
                :class="{ on: isActive('/service'), 'is-open': openSub === 'service' }"
              >
                <router-link to="/service/" @click.native="onParentNavClick('service', $event)">{{ $t('nav.services') }}</router-link>
                <span class="submenu-button" :class="{ 'submenu-opened': openSub === 'service' }" @click.prevent="toggleSub('service')"></span>
                <ul :class="{ open: openSub === 'service' }">
                  <li v-for="item in serviceNav" :key="item.slug">
                    <router-link :to="'/service/' + item.slug + '/'" @click.native="closeMobileMenu">{{ item.name || navItemLabel(item, 'serviceNav') }}</router-link>
                  </li>
                </ul>
              </li>
              <li
                class="default has-sub"
                :class="{ on: isActive('/about'), 'is-open': openSub === 'about' }"
              >
                <router-link to="/about/" @click.native="onParentNavClick('about', $event)">{{ $t('nav.about') }}</router-link>
                <span class="submenu-button" :class="{ 'submenu-opened': openSub === 'about' }" @click.prevent="toggleSub('about')"></span>
                <ul :class="{ open: openSub === 'about' }">
                  <li v-for="item in aboutNav" :key="item.slug">
                    <router-link :to="aboutLink(item)" @click.native="closeMobileMenu">{{ navItemLabel(item, 'aboutNav') }}</router-link>
                  </li>
                </ul>
              </li>
              <li class="default" :class="{ on: isActive('/contact') }">
                <router-link to="/contact/" @click.native="closeMobileMenu">{{ $t('nav.contact') }}</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="otherDiv flexend">
          <div class="ssDiv" :class="{ hover: searchOpen }">
            <a href="###" class="ssBtn flexcen" @click.prevent="searchOpen = !searchOpen">
              <i class="font_family icon-sousuo"></i>
            </a>
            <div class="searchDiv">
              <form @submit.prevent="submitSearch">
                <input type="text" v-model="keyword" :placeholder="$t('searchPlaceholder')">
                <button type="submit" class="flexcen"><i class="font_family icon-sousuo"></i></button>
              </form>
            </div>
          </div>
          <div class="langDiv flexend">
            <svg class="lang-globe" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.6"/>
              <ellipse cx="12" cy="12" rx="4" ry="9" fill="none" stroke="currentColor" stroke-width="1.4"/>
              <path d="M3.5 9.5h17M3.5 14.5h17" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
            </svg>
            <a href="###" :class="{ on: $i18n.locale === 'zh' }" @click.prevent="switchLang('zh')">中</a>
            <i class="lang-sep">{{ $t('langSep') }}</i>
            <a href="###" :class="{ on: $i18n.locale === 'en' }" @click.prevent="switchLang('en')">EN</a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { fetchSiteNav, resetSiteNavCache, getInitialSiteNav, fetchSolutionMegaNav } from '@/utils/siteNav'
import { saveLocale, getDefaultLocale } from '@/i18n'
import { applySiteBranding, fetchSiteBranding } from '@/utils/siteBranding'

export default {
  name: 'HiraysHeader',
  props: {
    innerPage: { type: Boolean, default: false }
  },
  data() {
    const initialNav = getInitialSiteNav(getDefaultLocale())
    return {
      productNav: initialNav.productNav,
      productMegaNav: initialNav.productMegaNav,
      applicationMegaNav: initialNav.applicationMegaNav,
      applicationNav: initialNav.applicationNav,
      newsNav: initialNav.newsNav,
      serviceNav: initialNav.serviceNav,
      aboutNav: initialNav.aboutNav,
      keyword: '',
      searchOpen: false,
      menuOpen: false,
      openSub: ''
    }
  },
  created() {
    this.loadNav(true)
  },
  mounted() {
    document.body.classList.toggle('on-fixed', this.innerPage)
    document.body.classList.toggle('page-inner', this.innerPage)
    document.addEventListener('click', this.onDocClick)
  },
  beforeDestroy() {
    this.closeMobileMenu()
    if (this.innerPage) {
      document.body.classList.remove('on-fixed')
      document.body.classList.remove('page-inner')
    }
    document.removeEventListener('click', this.onDocClick)
  },
  computed: {
    isHomeActive() {
      return this.$route.path === '/'
    }
  },
  watch: {
    '$route'() {
      this.closeMobileMenu()
    }
  },
  methods: {
    toggleMobileMenu() {
      this.menuOpen = !this.menuOpen
      document.body.classList.toggle('on-menu', this.menuOpen)
      if (!this.menuOpen) this.openSub = ''
    },
    closeMobileMenu() {
      this.menuOpen = false
      this.openSub = ''
      document.body.classList.remove('on-menu')
    },
    toggleSub(key) {
      this.openSub = this.openSub === key ? '' : key
    },
    /** On mobile: first tap expands submenu; on desktop allow normal navigation */
    onParentNavClick(key, e) {
      if (typeof window !== 'undefined' && window.matchMedia('(max-width: 992px)').matches) {
        if (this.openSub !== key) {
          e.preventDefault()
          this.openSub = key
          return
        }
      }
      this.closeMobileMenu()
    },
    applyNav(nav) {
      if (!nav) return
      this.productNav = nav.productNav
      this.productMegaNav = nav.productMegaNav || []
      this.applicationMegaNav = nav.applicationMegaNav || []
      this.applicationNav = nav.applicationNav
      this.newsNav = nav.newsNav
      this.serviceNav = nav.serviceNav
      this.aboutNav = nav.aboutNav
    },
    reloadCmsData() {
      resetSiteNavCache()
      this.loadNav(true)
    },
    async loadNav(force = false) {
      const nav = await fetchSiteNav(force, this.$i18n.locale)
      if (nav) this.applyNav(nav)
      await this.refreshMegaNavFromCms()
    },
    async refreshMegaNavFromCms() {
      try {
        const application = await fetchSolutionMegaNav(this.$i18n.locale, 1)
        if (application.length) {
          this.applicationMegaNav = application
          this.applicationNav = application.map(({ id, slug, name }) => ({ id, slug, name }))
        }
      } catch (e) {
        /* keep fetchSiteNav result */
      }
    },
    productDetailLink(slug, id) {
      return '/product/' + slug + '/' + id + '.html'
    },
    navItemLabel(item, group) {
      return this.$navItemLabel(group, item)
    },
    isActive(prefix) {
      return this.$route.path.startsWith(prefix)
    },
    aboutLink(item) {
      const hash = item.hash || 'page11'
      return { path: '/about/', hash: '#' + hash }
    },
    switchLang(locale) {
      this.$i18n.locale = locale
      saveLocale(locale)
      document.documentElement.lang = locale === 'zh' ? 'zh-CN' : 'en'
      fetchSiteBranding().then(branding => applySiteBranding(branding, locale))
      resetSiteNavCache()
      this.loadNav(true)
    },
    submitSearch() {
      if (!this.keyword.trim()) return
      this.searchOpen = false
      this.$router.push({ path: '/search/', query: { q: this.keyword.trim() } })
    },
    onDocClick(e) {
      if (!this.searchOpen) return
      const ss = this.$el.querySelector('.ssDiv')
      if (ss && !ss.contains(e.target)) this.searchOpen = false
    }
  }
}
</script>

<style scoped>
.lang-sep {
  font-style: normal;
  margin: 0 4px;
  color: inherit;
}
.lang-globe {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  flex-shrink: 0;
  color: #819fdb;
}
.header-container {
  position: relative;
}
</style>
